import { useState } from "react";
import { BRAND } from "@/data/brand";

/**
 * Floating WhatsApp CTA — opens wa.me with a pre-filled message.
 * Uses the brand gold for the button so it stays on-palette, with the
 * universally recognisable WhatsApp glyph in white inside.
 */
export default function WhatsAppFAB() {
  const [hover, setHover] = useState(false);

  // strip everything but digits for the wa.me URL
  const phone = BRAND.phone.replace(/[^\d]/g, "");
  const text = encodeURIComponent(
    "Hi LifeIQ — I'd like to learn more about the program."
  );
  const href = `https://wa.me/${phone}?text=${text}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with LifeIQ on WhatsApp"
      data-testid="whatsapp-fab"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onFocus={() => setHover(true)}
      onBlur={() => setHover(false)}
      className="fixed top-1/2 -translate-y-1/2 right-4 sm:right-5 z-[60] flex items-center gap-3 group"
    >
      <span
        className={`hidden sm:inline-block whitespace-nowrap bg-[#0D1B2A] text-white text-[13px] font-semibold px-4 py-2 rounded-sm shadow-[0_4px_20px_rgba(13,27,42,0.18)] transition-all duration-200 origin-right ${
          hover ? "opacity-100 translate-x-0" : "opacity-0 translate-x-2 pointer-events-none"
        }`}
      >
        Chat with us on WhatsApp
      </span>
      <span
        className="w-14 h-14 rounded-full bg-[#F57F17] text-white flex items-center justify-center shadow-[0_8px_24px_rgba(245,127,23,0.45)] hover:scale-105 active:scale-95 transition-transform"
      >
        <svg width="26" height="26" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true">
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.99 2.722.99.515 0 1.39-.115 1.776-.444.243-.214.6-1.06.6-1.388 0-.286-.93-.83-1.16-.943-.276-.143-1.054-.487-1.198-.487zM16 26a9.913 9.913 0 0 1-5.038-1.367l-3.6.948.96-3.51A9.96 9.96 0 0 1 6 16C6 10.486 10.486 6 16 6s10 4.486 10 10-4.486 10-10 10zm0-22C9.373 4 4 9.373 4 16c0 2.137.561 4.222 1.626 6.057L4 28l6.084-1.594A11.93 11.93 0 0 0 16 28c6.627 0 12-5.373 12-12S22.627 4 16 4z" />
        </svg>
      </span>
    </a>
  );
}
